<template>
  <div>
    <div class="docvue-background">
      <img src="/img/landing-page.jpg" />
    </div>
    <div style="margin-top: 7rem">
      <v-card class="elevation-1 card mt-4 pa-4 card-form justify-center" style="max-width: 800px; margin: 500px auto">
        <h3 class="text-h4 mb-4 pb-4">Error loading the application</h3>
        <div class="text-center pt-4 mt-4 mb-4 pb-4">
          We are sorry, an error occured while loading the application. Please try to logout and login again, and please
          report this to us to solve it for the future.
        </div>
        <div>
          <v-spacer />
          <v-btn @click="logout()" color="primary" block size="x-large" variant="flat">
            Logout
          </v-btn>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import localStorageService from "@/services/localStorageService.js";
import authService from "@/services/authService.js";
import { URL } from "@/env";

export default {
  name: "ErrorLoading",
  methods: {
    async logout() {
      await authService.logout();
      localStorageService.clear();
      this.$store.dispatch("auth0Store/clearSelectedCompanyId");
      await this.$auth0.logout({ logoutParams: { returnTo: URL } });
    },
  },
};
</script>
